import React, { useRef }  from 'react';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import emailjs from '@emailjs/browser';

function ContactForm() {

    const validationSchema = Yup.object().shape({
        ContactName: Yup.string()
            .required('Please enter your name')
            .max(25, 'Name should be atmost 25 charactors'),
        ContactEmail: Yup.string()
            .required('Please enter the email')
            .email('Email is invalid'),
        ContactMessage: Yup.string()
            .required('Please enter the message')
            .max(500, 'Message briefly'),
    });
    const formOptions = { resolver: yupResolver(validationSchema) };

    // get functions to build form with useForm() hook
    const { register, handleSubmit, reset, formState } = useForm(formOptions);
    const { errors } = formState;
    // functions to send form with emailjs hook
    const form = useRef();

    //console.log("error", errors); 

    const sendEmail = () => {

        emailjs.sendForm(process.env.REACT_APP_SERVICE_ID, process.env.REACT_APP_TEMPLATE_ID, form.current, process.env.REACT_APP_USER_ID)
        .then((result) => {
          //console.log(result.text);
          form.current.reset();
          reset();
        }, (error) => {
            return false;
        });
    };

    return(
        <div>
            <div className='flex flex-col mt-20 '>
                <div>
                    <h3 className='text-3xl md:text-4xl lg:text-5xl font-bold font-Marisa tracking-widepro uppercase text-center' >Contact</h3>
                </div>
                <div className='mb-5'>
                    <form ref={form} className='mt-10 grid place-items-center' autoComplete="off" onSubmit={handleSubmit(sendEmail)} noValidate>
                        <div className='relative w-11/12 lg:w-10/12'>
                            <input {...register('ContactName')} id='ContactName' name='ContactName' type='text' className='peer placeholder-transparent h-10 w-full p-2 border-2 border-gray-300 text-gray-900 hover:border-amber-700 
                            focus:outline-none focus:border-amber-700 hover:transition-all hover:ease-in-out hover:delay-150' placeholder="Name" required/>
                            <label htmlFor='ContactName' className='absolute left-2.5 rounded-sm bg-white pl-1 pr-1 -top-3.5 text-gray-600 text-sm peer-placeholder-shown:text-base
                             peer-placeholder-shown:text-gray-400 peer-placeholder-shown:top-2 transition-all duration-500 ease-in-out peer-focus:-top-3.5 peer-focus:text-amber-700
                             peer-focus:text-sm peer-focus:font-semibold'>Name</label>
                             <p className="ml-0 text-sm font-regular text-end text-red-500 transition-all duration-500 ease-in-out" >{errors.ContactName?.message}</p>
                        </div>
                        <div className='relative w-11/12 lg:w-10/12 mt-8'>
                            <input {...register("ContactEmail")} id='ContactEmail' name='ContactEmail' type='text' placeholder="Email" className='peer placeholder-transparent h-10 w-full p-2 border-2 border-gray-300 text-gray-900
                            hover:border-amber-700 focus:outline-none focus:border-amber-700 hover:transition-all hover:ease-in-out hover:delay-150' required/>
                            <label htmlFor='ContactEmail' className='absolute left-2.5 bg-white pl-1 pr-1 rounded-sm -top-3.5 text-gray-600 text-sm transition-all duration-500 ease-in-out peer-placeholder-shown:text-base 
                            peer-placeholder-shown:text-gray-400 peer-placeholder-shown:top-2 peer-focus:-top-3.5 peer-focus:text-amber-700 peer-focus:text-sm peer-focus:font-semibold
                            '>Email</label>
                            <p className="ml-0 text-sm font-regular text-end text-red-500 transition-all duration-500 ease-in-out" >{errors.ContactEmail?.message}</p>
                        </div>
                        <div className='relative w-11/12 lg:w-10/12 mt-8 mb-10'>
                            <textarea {...register("ContactMessage")}
                            id='ContactMessage' name='ContactMessage' type='textarea' rows="4" className='block h-35 rounded-sm resize-none peer placeholder-transparent w-full p-2 border-2 border-gray-300 
                            text-gray-900 hover:border-amber-700 focus:outline-none focus:border-amber-700 hover:transition-all hover:ease-in-out hover:delay-150' placeholder="Message" required></textarea>
                            <label htmlFor='ContactMessage' className='absolute left-2.5 bg-white pl-1 pr-1 -top-3.5 text-gray-600 text-sm peer-placeholder-shown:text-base 
                             peer-placeholder-shown:text-gray-400 peer-placeholder-shown:top-2 transition-all duration-500 ease-in-out peer-focus:-top-3.5 peer-focus:text-amber-700
                             peer-focus:text-sm peer-focus:font-semibold '>Message</label>
                             <p className="ml-0 text-sm font-regular text-end text-red-500 transition-all duration-500 ease-in-out" >{errors.ContactMessage?.message}</p>
                        </div>
                        <button type="submit" className='font-Lato font-bold uppercase rounded-sm pl-3 pr-3 pt-0.5 pb-0.5 text-gray-400 hover:text-amber-700 border-2 
                         border-gray-300 hover:border-amber-700 transition-all hover:transition-all hover:ease-in-out hover:delay-150' >send</button>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default ContactForm
